function FadeIn({
    children,
    duration = "normal",
    className = ""
}) {

    const animationClass = {
        fast: "fade-in-fast",
        normal: "fade-in",
        slow: "fade-in-slow"
    }[duration];

    return (
        <div className={`${animationClass} ${className}`}>
            {children}
        </div>
    );
}

export default FadeIn;
